import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ndps',
  templateUrl: './ndps.component.html',
  styleUrls: ['./ndps.component.css']
})
export class NDPSComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
